module.exports = __webpack_public_path__ + "img/oil_paint_6.cd3f53aa.png";